import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import {
  MatDateRangeInput,
  MatDateRangePicker,
  MatDatepickerToggle,
  MatEndDate,
  MatStartDate,
} from '@angular/material/datepicker';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute } from '@angular/router';
import { ResponseAgreementDto } from 'generated/apex-rest';
import { firstValueFrom } from 'rxjs';
import { FileUsageModule } from '../../../../../apex/src/app/components/file-usage/file-usage.module';
import { ModelRoleModule } from '../../../../../apex/src/app/components/model-role/model-role.module';
import { ObjectFieldComponent } from '../../../../../apex/src/app/components/object-field/object-field.component';
import { PageInfoModule } from '../../../../../apex/src/app/components/page-info/page-info.module';
import { TextUsageModule } from '../../../../../apex/src/app/components/text-usage/text-usage.module';
import { TranslateModule } from '../../../../../apex/src/app/components/translate/translate.module';
import { HistoryBackModule } from '../../../../../apex/src/app/directives/history-back/history-back.module';
import { CaseModule } from '../../../../../apex/src/app/features/case/case.module';
import { CaseService } from '../../../../../apex/src/app/features/case/case.service';
import { Case } from '../../../../../apex/src/app/models/case';
import { PortalAgreementService } from './portal-agreement.service';

@Component({
  selector: 'portal-agreement',
  templateUrl: './portal-agreement.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PageInfoModule,
    TranslateModule,
    FileUsageModule,
    HistoryBackModule,
    ModelRoleModule,
    TextUsageModule,
    MatFormField,
    MatInput,
    CdkTextareaAutosize,
    MatCheckbox,
    MatDateRangeInput,
    MatDateRangePicker,
    MatDatepickerToggle,
    MatLabel,
    MatStartDate,
    MatEndDate,
    MatSuffix,
    ObjectFieldComponent,
    CaseModule,
  ],

  providers: [PortalAgreementService, CaseService],
})
export default class PortalAgreementComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private portalAgreementService: PortalAgreementService,
    private caseService: CaseService,
  ) {}

  agreement: ResponseAgreementDto | null = null;
  cases: Case[] = [];
  loading = true;
  error: string | null = null;

  async ngOnInit(): Promise<void> {
    await this.fetchAgreementData();
  }

  async fetchAgreementData(): Promise<void> {
    try {
      this.loading = true;
      this.error = null;

      const params = await firstValueFrom(this.route.paramMap);
      const agreementId = params.get('id');

      if (!agreementId) {
        this.error = 'Agreement ID is required';

        return;
      }

      this.agreement = await this.portalAgreementService.getAgreementById(Number(agreementId));

      this.cases = await firstValueFrom(this.caseService.getCases({ Agreement: [Number(agreementId)] }));
    } catch (error) {
      this.error = 'Failed to load agreement. You may not have access to this agreement.';
      this.agreement = null;
      this.cases = [];
    } finally {
      this.loading = false;
    }
  }

  protected readonly Number = Number;
}
